export const dateForAPI = "YYYY-MM-DDTHH:mm:ss.SSS"
export const dateForList = "DD/MM/YYYY"
export const dateForListWithHours = "DD/MM/YYYY HH:mm:ss"
export const dateForValueInput = "YYYY-MM-DD"